// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d7006c94","86":"0dc1306f","181":"4ab48d47","297":"86d97388","377":"26f7c2f6","883":"782e73d3"}[chunkId] + ".chunk.js";
};